import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = {
  key: 1,
  class: "container-fluid my-2 flex-grow-1 overflow-auto"
}
const _hoisted_3 = { class: "d-flex justify-content-center mt-2 pal-button-container py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachPhysicianOrder = _resolveComponent("AttachPhysicianOrder")!
  const _component_Demographics = _resolveComponent("Demographics")!
  const _component_PayerInformation = _resolveComponent("PayerInformation")!
  const _component_ClinicalInformation = _resolveComponent("ClinicalInformation")!
  const _component_HealthHistory = _resolveComponent("HealthHistory")!
  const _component_Providers = _resolveComponent("Providers")!
  const _component_PharmacyAndDME = _resolveComponent("PharmacyAndDME")!
  const _component_AuthorizedContacts = _resolveComponent("AuthorizedContacts")!
  const _component_EmergencyPreparedness = _resolveComponent("EmergencyPreparedness")!
  const _component_AdvanceDirectives = _resolveComponent("AdvanceDirectives")!
  const _component_PatientGoals = _resolveComponent("PatientGoals")!
  const _component_ReferralInformation = _resolveComponent("ReferralInformation")!
  const _component_PatientNotes = _resolveComponent("PatientNotes")!
  const _component_MyNotes = _resolveComponent("MyNotes")!
  const _component_TabsLayout = _resolveComponent("TabsLayout")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "has-buttons": false,
    "has-title": false,
    id: "Pal_Covt_Pending_container",
    "content-class": "p-0"
  }, {
    content: _withCtx(() => [
      (!_ctx.isLoadError && !_ctx.isSaveInProgress)
        ? (_openBlock(), _createBlock(_component_TabsLayout, {
            key: 0,
            header: `Edit Palliative Patient - ${_ctx.formatName(
                        _ctx.patientOptions.data.firstName,
                        _ctx.patientOptions.data.lastName
                    )}`,
            tabs: _ctx.tabs,
            activeTab: _ctx.activeTab,
            handleTabChange: _ctx.handleTabChange,
            showErrors: 
                        (tab) =>
                            _ctx.getValidationDetails(tab.name, 'numberOfErrors') > 0 &&
                            _ctx.getValidationDetails(tab.name, 'isValidated')
                    ,
            showSuccess: 
                        (tab) =>
                            _ctx.getValidationDetails(tab.name, 'numberOfErrors') === 0 &&
                            _ctx.getValidationDetails(tab.name, 'isValidated')
                    ,
            numberOfErrors: (tab) => _ctx.getValidationDetails(tab.name, 'numberOfErrors'),
            showWarnings: (tab) => false
          }, _createSlots({
            forms: _withCtx(() => [
              (_ctx.isNoteIdRequested)
                ? (_openBlock(), _createElementBlock("section", {
                    key: 0,
                    class: _normalizeClass(`card px-0 material-card mx-3 mb-2 animated ${
                                _ctx.isNoteIdRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
                            } attach-physician-order`)
                  }, [
                    _createElementVNode("section", _hoisted_1, [
                      _createVNode(_component_AttachPhysicianOrder, {
                        entity: "DME/Supplies",
                        "order-id": _ctx.noteId,
                        "onUpdate:order-id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noteId) = $event)),
                        "url-note-id": _ctx.urlNoteId,
                        "patient-id": _ctx.patientId,
                        "open-orders": _ctx.openOrders,
                        "close-attach-order": _ctx.closeUpdateNoteId,
                        "provider-id": _ctx.patientOptions.data.providerId,
                        application: _ctx.application,
                        "account-id": _ctx.accountId,
                        "referral-id": _ctx.patientReferralId,
                        "is-attach-order-not-required": _ctx.isAttachOrderNotRequired,
                        "onUpdate:is-attach-order-not-required": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAttachOrderNotRequired) = $event))
                      }, null, 8 /* PROPS */, ["order-id", "url-note-id", "patient-id", "open-orders", "close-attach-order", "provider-id", "application", "account-id", "referral-id", "is-attach-order-not-required"])
                    ])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (!_ctx.isFormLoading)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                    (_ctx.activeTab === 1)
                      ? (_openBlock(), _createBlock(_component_Demographics, { key: 0 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 2)
                      ? (_openBlock(), _createBlock(_component_PayerInformation, { key: 1 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 3)
                      ? (_openBlock(), _createBlock(_component_ClinicalInformation, { key: 2 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 4)
                      ? (_openBlock(), _createBlock(_component_HealthHistory, { key: 3 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 5)
                      ? (_openBlock(), _createBlock(_component_Providers, { key: 4 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 6)
                      ? (_openBlock(), _createBlock(_component_PharmacyAndDME, { key: 5 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 7)
                      ? (_openBlock(), _createBlock(_component_AuthorizedContacts, { key: 6 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 8)
                      ? (_openBlock(), _createBlock(_component_EmergencyPreparedness, { key: 7 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 9)
                      ? (_openBlock(), _createBlock(_component_AdvanceDirectives, { key: 8 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 10)
                      ? (_openBlock(), _createBlock(_component_PatientGoals, { key: 9 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 11)
                      ? (_openBlock(), _createBlock(_component_ReferralInformation, { key: 10 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 12)
                      ? (_openBlock(), _createBlock(_component_PatientNotes, { key: 11 }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.activeTab === 13)
                      ? (_openBlock(), _createBlock(_component_MyNotes, { key: 12 }))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, [
            (!_ctx.isLoadError && !_ctx.isSaveInProgress)
              ? {
                  name: "buttons",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary me-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
                      }, "Cancel"),
                      (_ctx.activeTab !== 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary me-2",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.previous()))
                          }, " Previous "))
                        : _createCommentVNode("v-if", true),
                      (_ctx.activeTab !== 13)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary me-2",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next()))
                          }, " Next "))
                        : _createCommentVNode("v-if", true),
                      (_ctx.activeTab !== 13 && _ctx.activeTab !== 7)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-primary me-2",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save(_ctx.activeTab)))
                          }, " Save "))
                        : _createCommentVNode("v-if", true),
                      (_ctx.activeTab == 13)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.complete()))
                          }, " Complete "))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                }
              : undefined
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["header", "tabs", "activeTab", "handleTabChange", "showErrors", "showSuccess", "numberOfErrors", "showWarnings"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}